'use client';

import Link from 'next/link';
import Image from 'next/image';
import { X } from 'lucide-react';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  navItems: any[];
};

export default function MobileNavOverlay({ isOpen, onClose, navItems }: Props) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 bg-black/70 backdrop-blur-sm flex flex-col items-center justify-center">
      <button className="absolute top-6 right-6 text-white" onClick={onClose}>
        <X size={32} />
      </button>

      <div className="flex flex-col gap-10 text-white text-xl font-semibold">
        {navItems.map((item) => (
          <Link
            key={item.label}
            href={item.link}
            onClick={onClose}
            className="flex items-center gap-3 hover:text-ihs-blue transition"
          >
            <Image src={item.icon} alt={item.label} width={28} height={28} />
            {item.label}
          </Link>
        ))}
      </div>
    </div>
  );
}
